<template><div><h1>TypeScript 支持</h1>
<blockquote>
<p>即将支持</p>
</blockquote>
</div></template><script>
export default {
  head: {"title":"TypeScript 支持 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// typescript-155.vue?0855e21f